// extracted by mini-css-extract-plugin
module.exports = {"productTile":"_2qG85dG","productLink":"_3TqU78D"};